import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ContractTypeCreateDto, ContractTypeDto, ContractTypeExcelDownloadDto, ContractTypeUpdateDto, GetContractTypesInputDto } from '../dtos/contract-type/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class ContractTypeService {
  private restService = inject(RestService);
  apiName = 'Controlling';
  

  create = (input: ContractTypeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ContractTypeDto>({
      method: 'POST',
      url: '/api/controlling/contractTypes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/controlling/contractTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/controlling/contractTypes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ContractTypeDto>({
      method: 'GET',
      url: `/api/controlling/contractTypes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/controlling/contractTypes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetContractTypesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ContractTypeDto>>({
      method: 'GET',
      url: '/api/controlling/contractTypes',
      params: { vendorTypeId: input.vendorTypeId, vendorTypeName: input.vendorTypeName, useDepletionMaster: input.useDepletionMaster, name: input.name, measurementTypeId: input.measurementTypeId, isThirdPartyExporter: input.isThirdPartyExporter, isEligibleForElectronicInvoice: input.isEligibleForElectronicInvoice, contractTypeGroupId: input.contractTypeGroupId, contractTypeGroupName: input.contractTypeGroupName, code: input.code, applyDepletion2: input.applyDepletion2, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: ContractTypeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/controlling/contractTypes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, vendorTypeId: input.vendorTypeId, vendorTypeName: input.vendorTypeName, useDepletionMaster: input.useDepletionMaster, name: input.name, measurementTypeId: input.measurementTypeId, isThirdPartyExporter: input.isThirdPartyExporter, isEligibleForElectronicInvoice: input.isEligibleForElectronicInvoice, contractTypeGroupId: input.contractTypeGroupId, contractTypeGroupName: input.contractTypeGroupName, code: input.code, applyDepletion2: input.applyDepletion2, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ContractTypeDto[]>({
      method: 'GET',
      url: '/api/controlling/contractTypes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: ContractTypeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ContractTypeDto>({
      method: 'PUT',
      url: `/api/controlling/contractTypes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}